import type { FilterValue } from '../table-filters/encode';
import type { PaginationSearchParams } from '../table-filters/typed-filter-config';

/**
 * Build a stable, sorted search key string from sanitized filter and pagination
 * params. Used as the default React Query key so that only params the table
 * actually declares affect cache identity — UI-state params (e.g. ConfigurableTabs
 * deepLink) are excluded.
 */
export function buildSanitizedKey<
  TFilterParams extends Record<string, FilterValue> = Record<string, FilterValue>,
>(
  filterParams: TFilterParams,
  paginationParams: PaginationSearchParams,
): string {
  const entries = [
    ...Object.entries(filterParams),
    ...Object.entries(paginationParams),
  ]
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .sort(([a], [b]) => a.localeCompare(b));
  return new URLSearchParams(
    entries.map(([k, v]) => [k, Array.isArray(v) ? v.join(',') : String(v)]),
  ).toString();
}
